/**
 * The signed-in identity's organization memberships.
 * Populated by the org-switcher container from `sdk.auth.listOrganizations`
 * and read to decide whether to offer a switcher (>1 membership) at all.
 *
 * It lives in its own module, not beside `clearAuthAction`, so the teardown
 * registry can import it without an import cycle back through the auth actions.
 *
 * It IS account-scoped and IS reclaimed on sign-out — the previous comment here
 * claimed "in-memory only, so no explicit reset is needed", which is exactly the
 * reasoning that left one account's org list on screen after another account
 * signed in. See `stores/auth/teardown.ts`.
 */

import { atom } from 'jotai';
import type { OrgMembership } from '@localagent/sdk';
import { configureAtomDevtools } from '../utils/tracking';

export const organizationsAtom = configureAtomDevtools(
  atom<OrgMembership[]>([]),
  'auth/organizations',
);
